import { Rule } from './type';
import { CONSULTATION_STATE, CONSULTATION_TYPE, UserRole } from '@Utils/constants';
import useOnEnter from './on-enter';
import { useAppDispatch, useAppSelector } from '@Redux/hooks';
import { OrderActions } from '@Actions/OrderActions';
import { IQueryData } from '@Reducers/common';
import { IAppointments } from '@Reducers/checkout';
import { useCallback, useRef } from 'react';
import useConsultationType from '../../consultation-type';
import { AlloAuthUser } from '@Components/auth/utils';
import useAnasRouter from '@Utils/hooks/anas-router';
import { Routes } from '@Utils/hooks/anas-router/routes';
import { SelectablesActions } from '@Reducers/selectables';

export const useConfirmRule = (): Rule => {
  const router = useAnasRouter();
  const dispatch = useAppDispatch();
  const { consultationType } = useConsultationType();
  const auth: AlloAuthUser = useAppSelector((state) => state.auth.user);
  const commonIsLoading = useAppSelector((state) => state.common.isLoading);
  const queryData: IQueryData = useAppSelector((state) => state.common.queryData);
  const appointment: IAppointments = useAppSelector((state) => state.checkout.appointments);
  const appointmentRef = useRef(null);
  appointmentRef.current = appointment;

  const next = useCallback(() => {
    dispatch(OrderActions.ResetOrderData());
    dispatch(SelectablesActions.clear());
    router.push({ route: Routes.DASHBOARD });
  }, []);

  useOnEnter(() => {
    if (
      consultationType?.consultationCode === CONSULTATION_TYPE.FU &&
      auth?.roles?.includes(UserRole.PATIENT) &&
      queryData?.appointmentState === CONSULTATION_STATE.SCHEDULE
    ) {
      dispatch(SelectablesActions.clear());
      dispatch(OrderActions.ResetOrderData());
      router.push({
        route: Routes.ASSESSMENT,
        query: { form_type: 'FOLLOW_UP', appointment_id: queryData?.appointmentId },
      });
    }
  }, []);

  return {
    isLoading: commonIsLoading,
    next: next,
  };
};
